import React from "react";
import DynamicTable2 from "../../components/DynamicTable2";
import { EmailInput, PhoneNumberInput } from '../../components/FormInitiators';



const SrFixationForm1 = ({ formData, setFormData, onFormDataChange, onNext, showTable = false }) => {



    const handleInputChange = ({ target: { name, value } }) => {
        onFormDataChange({ [name]: value });
      };
    
      const onTableDataChange = (key) => (rows) => {
        setFormData((prevState) => {
          return { ...prevState, [key]: rows };
        });
      };

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

  return (

    <div className='google_forms'>
      <div className="forms">

    <form className="seventh-pay-arrears-form">
      <h3>वैयक्तिक माहिती</h3>

      <label>
      शाळा/कार्यालयाचे नाव:
        <input type="text" name="officeName" value={formData.officeName} onChange={handleInputChange} />
      </label>

      <label>
      कर्मचार्याचे नाव:
        <input type="text" name="employeeName" placeholder="Fname Fathersname Surname" value={formData.employeeName} onChange={handleInputChange}/>
      </label>

      <label>
      <EmailInput
          value={formData.email}
          onChange={handleInputChange}
        />
      </label>

      <label>
      <PhoneNumberInput
        value={formData.phoneNumber}
        onChange={handleInputChange}
        name="phoneNumber"
      />
      </label>

      <label>
        जन्म दिनांक:
        <div style={{ display: "flex", flexDirection: "column" }}>
              <input type="date" name="dateOfBirth" value={formData.dateOfBirth} onChange={handleInputChange}/>
        </div>
    </label>

    <label>
        नेमणूक दिनांक:
        <div style={{ display: "flex", flexDirection: "column" }}>
              <input type="date" name="dateOfJoining" value={formData.dateOfJoining} onChange={handleInputChange}/>
        </div>
    </label>

    {showTable && (
        <DynamicTable2
            tableName=" शैक्षणिक अर्हता:"
            columns={[
            { header: "परीक्षा", key: "exam", type: "text" },
            { header: "परीक्षा मंडळ/विद्यापीठ", key: "examCenter", type: "text" },
            { header: "उत्तीर्ण वर्ष", key: "year", type: "text" },
            { header: "श्रेणी", key: "grade", type: "text" },
            ]}
            localStorageKey="education"
            rows={formData.education}
            onTableDataChange={onTableDataChange("education")}
        />
        )}


    <label>
      01/01/2016 रोजी धारण केलेले पद:
        <input type="text"  name="designation" value={formData.designation}  onChange={handleInputChange}/>
      </label>


        <button className="seventh-pay-arrears-buttons-container" type="button" onClick={onNext}>
          Next
        </button>
    </form>
    </div>
    </div>
  );
};

export default SrFixationForm1 ;